import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';

import {PasswordChangeRequest, ProfileService} from '../../auth/profile/profile.service';
import {User} from '../../models/user.model';
import {notify} from '../../dx/notify/notify';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import smartcrop from 'smartcrop/smartcrop';

@Component({
  selector: 'lib-profile-edit-form',
  templateUrl: './profile-edit-form.component.html',
  styleUrls: ['./profile-edit-form.component.scss']
})
export class ProfileEditFormComponent implements OnInit {

  buttonOptions: any = {
    text: 'Enregistrer',
    type: 'default',
    useSubmitBehavior: true
  };

  passwordChangeRequest = new PasswordChangeRequest();
  changePasswordBtnOptions: any = {
    text: 'Changer',
    type: 'default',
    useSubmitBehavior: true
  };

  phonePattern: any = /^\+\s*212\s*\d\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{2}$/;
  loadIndicatorVisible = false;

  newUser: any;

  constructor(
    private profileService: ProfileService,
    public user: User,
  ) {
    this.passwordComparison = this.passwordComparison.bind(this);
  }

  ngOnInit(): void {
    this.newUser = {};
  }

  passwordComparison() {
    return this.passwordChangeRequest.new_password;
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.loadIndicatorVisible = true;
    this.profileService.update(this.newUser).pipe(catchError((error) => {
      this.loadIndicatorVisible = false;
      return throwError(error);
    })).subscribe(_ => {
      notify('Profil mis à jour avec succès');

      Object.assign(this.user, this.newUser);
      this.newUser = {};
      this.loadIndicatorVisible = false;
    });
  }

  onChangePasswordSubmit(e: Event) {
    e.preventDefault();
    this.profileService.changePassword(this.passwordChangeRequest).subscribe(_ => {
      notify('Le mot de passe a été changé avec succès');
    });
  }

  onFieldDataChanged(e: any) {
    Object.assign(this.newUser, e.component.option('formData'));
  }

  photoChange(e: string) {
    this.loadIndicatorVisible = true;
    this.profileService.update({photo: e} as any).pipe(catchError((error) => {
      this.loadIndicatorVisible = false;
      return throwError(error);
    })).subscribe(_ => {
      notify('Photo mis à jour avec succès');
      this.user.photo = e;
      this.loadIndicatorVisible = false;
    });
  }
}
